import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ForAllPage from './ForAll';
import ForWholesalePage from './ForWholesale';
import ForDesignersPage from './ForDesigners';

const PartnershipPage = () => {
  const { type } = useParams<{ type: string }>();

  switch (type) {
    case 'all':
      return <ForAllPage />;
    case 'wholesale':
      return <ForWholesalePage />;
    case 'designers':
      return <ForDesignersPage />;
    default:
      return <Navigate to="/partnership/all" replace />;
  }
};

export default PartnershipPage; 